<template>
  <div class="comparisonChart">
    <div class="comparisonChartTable">
      <table>
        <tr>
          <th>电站</th>
          <th>发电量(万度)</th>
          <th v-if ="lookMode =='sourceData'">月供电量(万度)</th>
          <th>完成率</th>
        </tr>
        <tr v-for="(item,index) in dataList" :key="index">
          <td v-if="item.name.indexOf('肥田21') != -1">
            <router-link to="/dataBig">
              <a href="#" style="color:#ffffff">
              {{item.name}}
              </a>
            </router-link>
          </td>
          <td v-else>{{item.name}}</td>
          <td>
            <div>
              {{item.powerGeneration}}
            </div>
          </td>
          <td v-if ="lookMode =='sourceData'">
            <div>
              {{item.mothPowerSupply}}
            </div>
          </td>
          <td class="td_total">
            <div class="totalPower">
              <div class="generalSupply" :style="{width:item.style}"></div>
            </div>
            {{item.monthCompletionRate}}%
          </td>
        </tr>
      </table>
      <div class="sprtDiv">
        <div v-for="(item,index) in index" :key="index">
          <div :class="[currentIndex==index?'success':'error','spot']" @click="currentClick(index)"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      form: {
        power_name: '',
        power_total: '',
        current_month: '',
        id: ''
      },
      lookMode:'',
      id:undefined,
      setInterval: 0,
      currentIndex: 0,
      index: 0,
      dataList: [],
      currentMothTotal: [],
      type: false,
      dialogVisible: false
    }
  },
  props: ['generatingCapacityList'],
  watch: {
    generatingCapacityList: function (newVal, oldVal) {
      console.log("generatingCapacityList")
      this.setInterval = 1
      this.currentMothTotal = []
      this.drawLine()
    }
  },
  mounted() {
    this.drawLine()
  },
  methods: {
    currentClick(e) {
      this.currentIndex = e
      this.dataList = this.currentMothTotal[e]
    },
    interval(e) {
      var that = this
      //循环遍历显示
      var i = 0;
      that.dataList = that.currentMothTotal[0]
      if (this.setInterval == 1) {
        that.id = setInterval(function () {
          that.currentIndex = i
          that.dataList = that.currentMothTotal[i]
          i = i + 1;
          if (i >= that.currentMothTotal.length) {
            i = 0;
          }
          console.log(that.dataList)
        }, 10000);
      } else {
        that.id = setInterval(function () {
          that.currentIndex = i
          that.dataList = that.currentMothTotal[i]
          i = i + 1;
          if (i >= that.currentMothTotal.length) {
            i = 0;
          }
          console.log(that.dataList)
        }, 10000);
      }
    },
    drawLine() {
      var that = this
      axios.get('/api/powermis/bigScreen/getGeneratingCapacityChart').then(response => {
        //数组分割
        for (var i = 0; i < response.data.data.currentMothTotal.length; i += 16) {
          for (var j = 0; j < response.data.data.currentMothTotal.length; j++) {
            response.data.data.currentMothTotal[j].style = response.data.data.currentMothTotal[j].monthCompletionRate + '%'
            response.data.data.currentMothTotal[j].type = false
          }
          that.currentMothTotal.push(response.data.data.currentMothTotal.slice(i, i + 16))
        }
        if (that.id) {
          clearInterval(that.id);
        }
        that.lookMode = response.data.data.lookMode
        that.index = that.currentMothTotal.length
        that.interval()
      })
    }
  }
}
</script>

<style lang="scss" scoped="" type="text/css">
body::-webkit-scrollbar {
  display: none;
}
table {
  width: 81%;
  margin: 0 auto;
  border-spacing: 0;
  color: white;
  font-size: 12px;
}
th {
  background-color: #3083c0;
  height: 45px;
  border: 0;
}
td:nth-child(1) {
  border-left: 1px solid #54aac8;
}
tr {
  text-align: center;
  width: 25%;
}
.totalPower {
  width: 72%;
  background-color: #4994e3;
  height: 9px;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  margin-right: 5%;
  margin-left: 0%;
}
.buttom_tisk {
  font-size: 12px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  color: white;
  justify-content: center;
  margin-top: 7%;
}
.buttom_left {
  display: flex;
  align-items: center;
}
.buttom_left div:nth-child(1) {
  background-image: linear-gradient(to right, #9a1f0d, #f77878);
  width: 20px;
  height: 9px;
  margin-right: 9%;
  margin-left: -9%;
}
.buttom_right {
  display: flex;
  align-items: center;
  margin-left: 9%;
}
.buttom_right div:nth-child(1) {
  background-image: linear-gradient(to right, #33bbde, #5775e7);
  width: 20px;
  height: 9px;
  margin-right: 5%;
  margin-left: -7%;
}
.generalSupply {
  width: 95%;
  background-image: linear-gradient(to right, #9a1f0d, #f77878);
  height: 9px;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}
td {
  text-align: center;
  border-bottom: 1px solid #54aac8;
  border-top: 0;
  border-right: 1px solid #54aac8;
  height: 37px;
  width: 25%;
}

.comparisonChart {
  width: 21.25%;
  margin-left: 2.33%;
  background: url(../assets/comparisonChart.png) no-repeat;
  background-size: 100% 100%;
  height: 863px;
}
.comparisonChart .comparisonChartTable {
  position: relative;
  width: 100%;
  margin: 0 auto;
  margin-top: 24%;
  height: 724px;
  overflow: auto;
}
.td_total {
  display: flex;
  align-items: center;
  width: 100%;
}
.edit {
  position: absolute;
  margin-left: 0.2%;
  margin-top: 11px;
  cursor: pointer;
}
div::-webkit-scrollbar {
  display: none;
}
.spot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #ffffff;
}
.sprtDiv {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 98%;
  left: 50%;
  div {
    margin-right: 5px;
    margin-left: -2px;
  }
}
.success {
  background-color: #4994e3;
}
</style>



// WEBPACK FOOTER //
// src/components/comparisonChart.vue